import { mapActions } from 'vuex'

export default {


  mounted() {

  },

  methods: {

    ...mapActions(['requestPageData', 'pageLoading', 'pageLoaded']),


    async getArchive(postType,length=0,tags='') {

      //引数に_fieldsを加える場合、idとtypeを入れないとWP REST Cacheが更新されないので注意

      return await this.requestPageData(
        {
          name: name,
          query: 'posts?post_type=' + postType + '&per_page='+(length==0 ? 100 : length) + (tags=='' ? '' : '&tags='+tags)
                +'&_fields[]=id&_fields[]=type&_fields[]=slug&_fields[]=title&_fields[]=featured_image&_fields[]=featured_media&size=medium&_fields[]=tags&_fields[]=acf',
          isSingle: false
        })
    },

    async getRelatedPosts(id) {

      return await this.requestPageData(
        {
          name: name,
          query: 'related-posts?id='+id,
          isSingle: false
        })
    },

    async getPost(postType, name, isSlug = true) {
      var q = isSlug ? 'posts?post_type=' + postType + '&slug=' + name : 'posts?post_type=' + postType + '&id=' + name
      return await this.requestPageData(
        {
          name: name,
          query: q,
          isSingle: true
        })
    },

    async getPage(name, isSlug = true) {
      var q = isSlug ? 'pages?slug=' + name : 'page/' + name
      return await this.requestPageData(
        {
          name: name,
          query: q,
          isSingle: true
        })
    },

    async getTags(postType = 'post') {
      return await this.requestPageData(
        {
          name: 'tags/' + postType,
          query: 'tags?post_type=' + postType,
          isSingle: false
        })
    }

  }
}